import { styled } from "@mui/material/styles";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { dateShortString } from "utils/date-format";
import { Box } from "@mui/system";
import Divider from "@mui/material/Divider";

const StyledListItem = styled(ListItem)(({ theme, active }) => ({
	...(active && {
		backgroundColor: theme.palette.background.paper,
	}),
}));

function EventBookingListItem({ booking }) {
	return (
		<>
			<StyledListItem button className="px-16 py-12">
				<ListItemText
					classes={{
						root: "min-w-px px-16",
						primary: "font-medium text-14",
						secondary: "truncate",
					}}
					primary={
						<span className="font-medium text-14">{booking.event.name}</span>
					}
					secondary={<>{booking.numberOfGuests} Guests</>}
				/>

				<div className="flex flex-col justify-center items-end">
					<Typography
						className="whitespace-nowrap mb-8 font-medium text-12"
						color="textSecondary"
					>
						<span
							className="whitespace-nowrap mb-8 font-medium text-12"
							color="textSecondary"
						>
							{dateShortString(booking.eventDate)}
						</span>
					</Typography>

					<Box
						sx={{
							backgroundColor: "secondary.main",
							color: "secondary.contrastText",
						}}
						className="flex items-center justify-center min-w-24 h-24 rounded-full font-medium text-12 text-center"
					>
						{booking.eventStartTime} - {booking.eventEndTime}
					</Box>
				</div>
			</StyledListItem>
			<Divider className="my-2" />
		</>
	);
}

export default EventBookingListItem;
